import type { Field } from "@fobu/schema";
import { Consent, Dropdown, MultipleChoice, SingleChoice, YesNo } from "./fields/ChoiceFields";
import { Matrix } from "./fields/MatrixField";
import { Nps, Rating, Scale, Slider } from "./fields/ScaleFields";
import { DateTimeInput, LongText, NumberInput, TextInput } from "./fields/TextFields";
import type { FieldProps } from "./fields/types";
import { GroupField } from "./fields/GroupField";
import { LazyEmailVerify, LazyAddress, LazyAmount, LazyDateRange, LazyLookup, LazyOrder, LazyRanking, LazySepa, LazyFileUpload, LazyPoll, LazySignature } from "./Common";

/** Eingabeelement je Feldtyp (auch für Unterfragen in wiederholbaren Gruppen). */
export function Control(props: FieldProps<Field>) {
  // Die Feldtyp-Unterscheidung passiert im switch; die Props sind dort korrekt typisiert.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const p = props as any;
  switch (props.field.type) {
    case "email":
      return p.field.verify ? <LazyEmailVerify {...p} /> : <TextInput {...p} />;
    case "short_text":
    case "phone":
    case "url":
      return <TextInput {...p} />;
    case "long_text":
      return <LongText {...p} />;
    case "number":
      return <NumberInput {...p} />;
    case "date":
    case "time":
    case "datetime":
      return <DateTimeInput {...p} />;
    case "single_choice":
      return <SingleChoice {...p} />;
    case "multiple_choice":
      return <MultipleChoice {...p} />;
    case "dropdown":
      return <Dropdown {...p} />;
    case "yes_no":
      return <YesNo {...p} />;
    case "consent":
      return <Consent {...p} />;
    case "rating":
      return <Rating {...p} />;
    case "nps":
      return <Nps {...p} />;
    case "scale":
      return <Scale {...p} />;
    case "slider":
      return <Slider {...p} />;
    case "matrix":
      return <Matrix {...p} />;
    case "ranking":
      return <LazyRanking {...p} />;
    case "file_upload":
      return <LazyFileUpload {...p} />;
    case "signature":
      return <LazySignature {...p} />;
    case "group":
      return <GroupField {...p} />;
    case "lookup":
      return <LazyLookup {...p} />;
    case "poll":
      return <LazyPoll {...p} />;
    case "address":
      return <LazyAddress {...p} />;
    case "date_range":
      return <LazyDateRange {...p} />;
    case "amount":
      return <LazyAmount {...p} />;
    case "order":
      return <LazyOrder {...p} />;
    case "sepa":
      return <LazySepa {...p} />;
  }
}

